import { render, staticRenderFns } from "./SipSettings.vue?vue&type=template&id=574aeb1f"
import script from "./SipSettings.vue?vue&type=script&lang=js"
export * from "./SipSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports